<template>
  <div id="page-layout">
    <form class="edit-form login-form"
          novalidate
          @submit.prevent="handleSubmit"
          name="login"
          v-if="!isLogged()">

      <h1 class="big-title">{{ $t("titles.login") }}</h1>

      <c-input ref="email" name="email" label="user.email" v-model.trim="login.email" type="text" :autofocus="true"/>
      <c-input ref="password" name="password" label="user.password" v-model.trim="login.password" type="password"/>

      <router-link to="/forgotPassword" class="forgot-password-link" href>{{ $t("titles.forgot_password") }}
      </router-link>

      <div class="actions login-actions">
        <input class="solid-button" style="flex-grow: 1" type="submit" v-bind:value="$t('actions.login')">
      </div>
    </form>
    <div class="simple-page-layout" v-if="isLogged()">

      <div class="big-title">{{$t('titles.logout')}}</div>

      <div class="actions login-actions">
        <button class="solid-button" style="flex-grow: 1" type="button" v-on:click="logout()">
          {{$t('header.logout')}}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import LoginUser from "../models/LoginUser.js";
  import userService from "../services/userService.js";

  export default {
    data() {
      return {
        login: LoginUser
      };
    },
    methods: {
      isLogged() {
        return userService.isLogged();
      },
      handleSubmit() {
        userService
          .login(this.login)
          .then(() => {
            this.$store.dispatch('alert/clear');
            this.$store.dispatch('user/login').then(() => {
              this.$router.push({path: '/'})
            });
          })
          .catch(() => {
            this.$store.dispatch('alert/error', {message: this.$t("alerts.login_error")});
          });
      },
      logout() {
        userService.logout();
        this.$store.dispatch('user/logout');
        location.reload();
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import "../style/form.scss";

  #page-layout {
    display: grid;
    grid-template-columns: 30% [content] auto 30%;
    padding-top: 8%;
    padding-bottom: 4%;
  }

  .forgot-password-link {
    @extend %font-default;
    font-size: 14px;
    line-height: normal;
    letter-spacing: normal;
    color: $blue;

    text-align: right;
    padding: 5px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue